import { FC } from 'react';
import { createPortal } from 'react-dom';
import classNames from 'classnames';

import Modal from '@z-components/atoms/Modal';

import TierItem from './TierItem';
import styles from './TierExplanationModal.module.scss';

const tiers = [
  {
    name: 'diamond',
    text: {
      en: 'Diamond',
      ja: 'ダイアモンドランク',
    },
  },
  {
    name: 'platinum',
    text: {
      en: 'Platinum',
      ja: 'プラチナランク',
    },
  },
  {
    name: 'gold',
    text: {
      en: 'Gold',
      ja: 'ゴールドランク',
    },
  },
  {
    name: 'silver',
    text: {
      en: 'Silver',
      ja: 'シルバーランク',
    },
  },
  {
    name: 'bronze',
    text: {
      en: 'Bronze',
      ja: 'ブロンズランク',
    },
  },
  {
    name: 'new-user',
    text: {
      en: 'New User',
      ja: 'ニューユーザー',
    },
  },
];

interface Props {
  handleModalDismiss: () => void;
  language: 'en' | 'ja';
}
const TierExplanationModal: FC<Props> = ({ language, handleModalDismiss }) =>
  createPortal(
    <Modal
      modalName="tier-explanation"
      hasMaxWidth={true}
      isCloseButtonHidden={true}
      isModalRounded={true}
      onDismiss={handleModalDismiss}
    >
      <>
        {tiers.map(({ name, text }) => (
          <div key={name} className={classNames(styles['pro-tier-icons-container'], styles[name])}>
            <span className={styles['pro-tier-icon']}>
              <img alt={`Tier ${name}`} src={`/static/images/tiers/${name}.svg`} />
            </span>
            <TierItem name={name} text={text[language]} />
          </div>
        ))}
      </>
    </Modal>,
    document.body
  );

export default TierExplanationModal;
export type { Props as TierExplanationModal };
